import {
  AWS_ENVIRONMENTS,
  getAwsEnvironmentConfig,
  resolveAwsEnvironment,
} from "@/config/awsEnvironment.js";

const AUTH_KEYS = ["user_id", "currentUser", "user_email_id", "isLoggedIn", "aws_environment"];

const LEGACY_AUTH_KEYS = ["user_id", "currentUser", "user_email_id", "isLoggedIn"];

function currentEnvironment() {
  return resolveAwsEnvironment();
}

function scopedKey(key) {
  return `yandle-bms:${currentEnvironment()}:${key}`;
}

function readScoped(key) {
  return localStorage.getItem(scopedKey(key));
}

function writeScoped(key, value) {
  localStorage.setItem(scopedKey(key), value);
}

function removeScoped(key) {
  localStorage.removeItem(scopedKey(key));
}

function migrateLegacyKey(key) {
  const legacy = localStorage.getItem(key);
  if (legacy == null) return null;
  writeScoped(key, legacy);
  localStorage.removeItem(key);
  return legacy;
}

export function getAuthItem(key) {
  const scoped = readScoped(key);
  if (scoped != null) return scoped;
  return migrateLegacyKey(key);
}

export function setAuthItem(key, value) {
  writeScoped(key, value);
  localStorage.removeItem(key);
}

export function removeAuthItem(key) {
  removeScoped(key);
  localStorage.removeItem(key);
}

export function getStoredUserId() {
  const userId = getAuthItem("user_id");
  if (userId) return userId;
  return readStoredCurrentUser()?.user_id ?? null;
}

export function getStoredUserEmail() {
  return getAuthItem("user_email_id") || "";
}

export function readStoredCurrentUser() {
  try {
    return JSON.parse(getAuthItem("currentUser") || "null");
  } catch {
    return null;
  }
}

export function markAuthEnvironment() {
  setAuthItem("aws_environment", currentEnvironment());
}

export function getMarkedAuthEnvironment() {
  return getAuthItem("aws_environment");
}

export function clearAuthStorage() {
  for (const key of AUTH_KEYS) {
    removeAuthItem(key);
  }

  for (const key of LEGACY_AUTH_KEYS) {
    localStorage.removeItem(key);
  }
}

export function purgeForeignEnvironmentArtifacts(config = getAwsEnvironmentConfig()) {
  if (typeof localStorage === "undefined") return;

  const otherEnvironment = config.environment === "dev" ? "prod" : "dev";
  const foreignConfig = AWS_ENVIRONMENTS[otherEnvironment];
  const amplifyPrefix = `yandle-amplify:${otherEnvironment}::`;

  const keysToRemove = [];

  for (let index = 0; index < localStorage.length; index += 1) {
    const key = localStorage.key(index);
    if (!key) continue;

    if (key.startsWith(amplifyPrefix)) {
      keysToRemove.push(key);
      continue;
    }

    if (
      key.startsWith("CognitoIdentityServiceProvider.") &&
      key.includes(foreignConfig.userPoolClientId)
    ) {
      keysToRemove.push(key);
    }
  }

  for (const key of AUTH_KEYS) {
    keysToRemove.push(`yandle-bms:${otherEnvironment}:${key}`);
  }

  [...new Set(keysToRemove)].forEach((key) => localStorage.removeItem(key));
}
